export interface GetIsSubscribedForContentParams {
  isIconic?: boolean;
  isIconicPro?: boolean;
  isIconicUser?: boolean;
  isIconicProUser?: boolean;
  isPlusUser?: boolean;
}

/**
 * Whether the user holds a subscription tier that unlocks the content.
 *
 * User access (higher includes lower):
 * - Iconic Pro → Iconic Pro + Iconic + Plus
 * - Iconic → Iconic + Plus
 * - Plus → Plus
 *
 * Content requirement is checked highest-first so if a course is tagged
 * both Iconic and Iconic Pro, Iconic Pro is required.
 */
const getIsSubscribedForContent = ({
  isIconic = false,
  isIconicPro = false,
  isIconicUser = false,
  isIconicProUser = false,
  isPlusUser = false
}: GetIsSubscribedForContentParams): boolean => {
  const canAccessPlus = isPlusUser || isIconicUser || isIconicProUser;
  const canAccessIconic = isIconicUser || isIconicProUser;
  const canAccessIconicPro = isIconicProUser;

  if (isIconicPro) return canAccessIconicPro;
  if (isIconic) return canAccessIconic;
  return canAccessPlus;
};

export default getIsSubscribedForContent;
